import axios from 'axios';

let Promise = require('es6-promise').Promise;

export function login(params) {
    return new Promise(function(resolve, reject) {
        axios.defaults.headers.common['Content-Type'] = 'application/json';

        axios.post(`https://lifetech-api-stg.herokuapp.com/api/auth/sign_in?email=${params.email}&password=${params.password}`)
        .then(response => {
            if(response && !response.errors) {
                resolve(response)
            } else if(response && response.errors){
                reject(response.errors)
            }
        })
        .catch((error) => {
            console.log(error.response)
            // reject(error.response.data.errors);
        });
    })
}

export function signup(params) {

    return new Promise(function(resolve, reject) {
        axios.defaults.headers.common['Content-Type'] = 'application/json';

        axios.post(`https://lifetech-api-stg.herokuapp.com/api/auth?email=${params.email}&password=${params.password}&password_confirmation=${params.password_confirmation}&nickname=${params.nickname}&name=${params.name}`)
        .then(response => {
            console.log(response)
            if(response && !response.errors) {
                resolve(response)
            } else if(response && response.errors){
                reject(response.errors)
            }
        })
        .catch(function(error) {
            reject(error.response.data.errors.full_messages);
        });
    })
}

// DASHBOARD API CALLS
export function updateUserProfile(data) {

    return new Promise(function(resolve, reject) {
        if(data) {
            axios.defaults.headers.common['Content-Type'] = 'application/json';
            const url = `https://lifetech-api-stg.herokuapp.com/api/v1/user/${localStorage.getItem("user_id")}/profile/edit?`;
            const authParams = `uid=${localStorage.getItem('uid')}&access-token=${localStorage.getItem('accessToken')}&expiry=${localStorage.getItem('expiry')}&client=${localStorage.getItem('client')}&token-type=Bearer`;
            const params =
                `&email=${data.email}&height=${data.height}&weight=${data.weight}&name=${data.name}&phone=${data.phone}&gender=${data.gender}&birth_date=${data.birth_date}`;
            axios.post(url + authParams + params)
                .then(response => {
                    if (response && !response.errors) {
                        resolve(response)
                    } else if (response && response.errors) {
                        reject(response.errors)
                    }
                })
                .catch(function (error) {
                    reject(error);
                });
        }
    })
}

export function getLastData(user_id) {

    return new Promise(function(resolve, reject) {
        axios.defaults.headers.common['Content-Type'] = 'application/json';
        const url = 'https://lifetech-api-stg.herokuapp.com/api/v1/lastData/' + user_id + '?';
        const authParams = `uid=${localStorage.getItem('uid')}&access-token=${localStorage.getItem('accessToken')}&expiry=${localStorage.getItem('expiry')}&client=${localStorage.getItem('client')}&token-type=Bearer`;
        axios.get(url+authParams)
        .then(response => {
            if(response && !response.errors) {
                resolve(response)
            } else if(response && response.errors){
                reject(response.errors)
            }
        })
        .catch(function(error) {
            reject(error);
        });
    })
}


// GUARDIANS API CALLS

export function getProtegees() {

    return new Promise(function(resolve, reject) {
        axios.defaults.headers.common['Content-Type'] = 'application/json';
        const url = `https://lifetech-api-stg.herokuapp.com/api/v1/user/${localStorage.user_id }/protegees?`;
        const authParams = `uid=${localStorage.getItem('uid')}&access-token=${localStorage.getItem('accessToken')}&expiry=${localStorage.getItem('expiry')}&client=${localStorage.getItem('client')}&token-type=Bearer`;
        axios.get(url+authParams)
        .then(response => {
            if(response && !response.errors) {
                resolve(response)
            } else if(response && response.errors){
                reject(response.errors);
            }
        })
        .catch(function(error) {
            reject(error);
        });
    })
}

export function getGuardians() {

    return new Promise(function(resolve, reject) {
        axios.defaults.headers.common['Content-Type'] = 'application/json';
        const url = `https://lifetech-api-stg.herokuapp.com/api/v1/user/${localStorage.user_id }/guardians?`;
        const authParams = `uid=${localStorage.getItem('uid')}&access-token=${localStorage.getItem('accessToken')}&expiry=${localStorage.getItem('expiry')}&client=${localStorage.getItem('client')}&token-type=Bearer`;
        axios.get(url+authParams)
        .then(response => {
            if(response && !response.errors) {
                resolve(response)
            } else if(response && response.errors){
                reject(response.errors);
            }
        })
        .catch(function(error) {
            reject(error);
        });
    })
}

export function addGuardiansWithEmail(email,data , alerts) {

    return new Promise(function(resolve, reject) {
        axios.defaults.headers.common['Content-Type'] = 'application/json';
        const url = `https://lifetech-api-stg.herokuapp.com/api/v1/user/${localStorage.getItem('user_id')}/add_guardian?email=${email}&data_visible=${data}&notification=${alerts}&`;
        const authParams = `uid=${localStorage.getItem('uid')}&access-token=${localStorage.getItem('accessToken')}&expiry=${localStorage.getItem('expiry')}&client=${localStorage.getItem('client')}&token-type=Bearer`;
        axios.post(url+authParams)
        .then(response => {
            if(response && !response.errors) {
                resolve(response)
            } else if(response && response.errors){
                reject(response.errors)
            }
        })
        .catch(function(error) {
            reject(error);
        });
    })
}

export function updateGuardianPermissions(guardian_id, data, alerts) {

    return new Promise(function(resolve, reject) {
        axios.defaults.headers.common['Content-Type'] = 'application/json';
        const url = `https://lifetech-api-stg.herokuapp.com/api/v1/permissions/edit?user_id=${localStorage.getItem('user_id')}&guardian_id=${guardian_id}&notification=${alerts}&data_visible=${data}`;
        const authParams = `uid=${localStorage.getItem('uid')}&access-token=${localStorage.getItem('accessToken')}&expiry=${localStorage.getItem('expiry')}&client=${localStorage.getItem('client')}&token-type=Bearer`;
        axios.post(url+authParams)
        .then(response => {
            if(response && !response.errors) {
                resolve(response)
            } else if(response && response.errors){
                reject(response.errors)
            }
        })
        .catch(function(error) {
            reject(error);
        });
    })
}

export function getUserProfile() {

    return new Promise(function(resolve, reject) {
        axios.defaults.headers.common['Content-Type'] = 'application/json';
        const url = 'https://lifetech-api-stg.herokuapp.com/api/v1/user/' + localStorage.user_id + '/profile?';
        const authParams = `uid=${localStorage.getItem('uid')}&access-token=${localStorage.getItem('accessToken')}&expiry=${localStorage.getItem('expiry')}&client=${localStorage.getItem('client')}&token-type=Bearer`;
        axios.get(url+authParams)
        .then(response => {
            if(response && !response.errors) {
                resolve(response)
            } else if(response && response.errors){
                reject(response.errors)
            }
        })
        .catch(function(error) {
            reject(error);
        });
    })
}

export function uploadProfilePicture(picture) {
    return new Promise(function(resolve, reject) {
        axios.defaults.headers.common['Content-Type'] = 'application/json';
        const url = `https://lifetech-api-stg.herokuapp.com/api/v1/user/${localStorage.getItem('user_id')}/profile_picture?uid=${localStorage.getItem('uid')}&access-token=${localStorage.getItem('accessToken')}&expiry=${localStorage.getItem('expiry')}&client=${localStorage.getItem('client')}&token-type=Bearer`;
        axios.post(url,{ body: {data: picture}})
        .then(response => {
            if(response && !response.errors) {
                resolve(response)
            } else if(response && response.errors){
                reject(response.errors)
            }
        })
        .catch(function(error) {
            reject(error);
        });
    })
}

export function getProfilePicture() {

    return new Promise(function(resolve, reject) {
        axios.defaults.headers.common['Content-Type'] = 'application/x-www-form-urlencoded';

        const url = `https://lifetech-api-stg.herokuapp.com/api/v1/user/${localStorage.getItem('user_id')}/profile_picture`;
        const authParams = `?uid=${localStorage.getItem('uid')}&access-token=${localStorage.getItem('accessToken')}&expiry=${localStorage.getItem('expiry')}&client=${localStorage.getItem('client')}&token-type=Bearer`;
        axios.get(url+authParams)
        .then(response => {
            if(response && !response.errors) {
                resolve(response)
            } else if(response && response.errors){
                reject(response.errors)
            }
        })
        .catch(function(error) {
            reject(error);
        });
    })
}

export function getPostsListForUser(user_id,pageNumber=1) {

    return new Promise(function(resolve, reject) {
        axios.defaults.headers.common['Content-Type'] = 'application/x-www-form-urlencoded';

        const url = `https://lifetech-api-stg.herokuapp.com/api/v1/posts/${user_id}?page=${pageNumber}&per_page=5`;
        const authParams = `&uid=${localStorage.getItem('uid')}&access-token=${localStorage.getItem('accessToken')}&expiry=${localStorage.getItem('expiry')}&client=${localStorage.getItem('client')}&token-type=Bearer`;
        axios.get(url+authParams)
        .then(response => {
            if(response && !response.errors) {
                resolve(response)
            } else if(response && response.errors){
                reject(response.errors)
            }
        })
        .catch(function(error) {
            reject(error);
        });
    })
}

export function sendPostFromUser(params) {

    return new Promise(function(resolve, reject) {
        axios.defaults.headers.common['Content-Type'] = 'application/x-www-form-urlencoded';
        console.log(params)
        const url = `https://lifetech-api-stg.herokuapp.com/api/v1/post/${localStorage.getItem('user_id')}?text=${params.text}`;
        const authParams = `&uid=${localStorage.getItem('uid')}&access-token=${localStorage.getItem('accessToken')}&expiry=${localStorage.getItem('expiry')}&client=${localStorage.getItem('client')}&token-type=Bearer`;
        axios.post(url+authParams, { body: {data: params.photo}})
        .then(response => {
            if(response && !response.errors) {
                resolve(response)
            } else if(response && response.errors){
                reject(response.errors)
            }
        })
        .catch(function(error) {
            reject(error);
        });
    })
}

export function getNewslinePosts(pageNumber = 1) {

    return new Promise(function(resolve, reject) {
        axios.defaults.headers.common['Content-Type'] = 'application/x-www-form-urlencoded';

        const url = `https://lifetech-api-stg.herokuapp.com/api/v1/newsline_posts/${localStorage.getItem('user_id')}?page=${pageNumber}&per_page=6`;
        const authParams = `&uid=${localStorage.getItem('uid')}&access-token=${localStorage.getItem('accessToken')}&expiry=${localStorage.getItem('expiry')}&client=${localStorage.getItem('client')}&token-type=Bearer`;
        axios.get(url+authParams)
        .then(response => {
            if(response && !response.errors) {
                resolve(response)
            } else if(response && response.errors){
                reject(response.errors)
            }
        })
        .catch(function(error) {
            reject(error);
        });
    })
}

export function getUserSummaryInfos(user_id) {

    return new Promise(function(resolve, reject) {
        axios.defaults.headers.common['Content-Type'] = 'application/x-www-form-urlencoded';

        const url = `https://lifetech-api-stg.herokuapp.com/api/v1/get_user_summary_infos/${user_id}`;
        const authParams = `?uid=${localStorage.getItem('uid')}&access-token=${localStorage.getItem('accessToken')}&expiry=${localStorage.getItem('expiry')}&client=${localStorage.getItem('client')}&token-type=Bearer`;
        axios.get(url+authParams)
        .then(response => {
            if(response && !response.errors) {
                resolve(response)
            } else if(response && response.errors){
                reject(response.errors)
            }
        })
        .catch(function(error) {
            reject(error);
        });
    })
}

export function getPostLikes(post_id) {

    return new Promise(function(resolve, reject) {
        axios.defaults.headers.common['Content-Type'] = 'application/x-www-form-urlencoded';

        const url = `https://lifetech-api-stg.herokuapp.com/api/v1/get_likes_for_post/${post_id}`;
        const authParams = `?uid=${localStorage.getItem('uid')}&access-token=${localStorage.getItem('accessToken')}&expiry=${localStorage.getItem('expiry')}&client=${localStorage.getItem('client')}&token-type=Bearer`;
        axios.get(url+authParams)
        .then(response => {
            if(response && !response.errors) {
                resolve(response)
            } else if(response && response.errors){
                reject(response.errors)
            }
        })
        .catch(function(error) {
            reject(error);
        });
    })
}

export function getPostComments(post_id) {

    return new Promise(function(resolve, reject) {
        axios.defaults.headers.common['Content-Type'] = 'application/x-www-form-urlencoded';

        const url = `https://lifetech-api-stg.herokuapp.com/api/v1/get_comments_for_post/${post_id}`;
        const authParams = `?uid=${localStorage.getItem('uid')}&access-token=${localStorage.getItem('accessToken')}&expiry=${localStorage.getItem('expiry')}&client=${localStorage.getItem('client')}&token-type=Bearer`;
        axios.get(url+authParams)
        .then(response => {
            if(response && !response.errors) {
                resolve(response)
            } else if(response && response.errors){
                reject(response.errors)
            }
        })
        .catch(function(error) {
            reject(error);
        });
    })
}

export function sendCommentForPost(post_id,comment) {

    return new Promise(function(resolve, reject) {
        axios.defaults.headers.common['Content-Type'] = 'application/x-www-form-urlencoded';

        const url = `https://lifetech-api-stg.herokuapp.com/api/v1/post/${localStorage.getItem('user_id')}/comment?post_id=${[post_id]}&text=${comment}`;
        const authParams = `&uid=${localStorage.getItem('uid')}&access-token=${localStorage.getItem('accessToken')}&expiry=${localStorage.getItem('expiry')}&client=${localStorage.getItem('client')}&token-type=Bearer`;
        axios.post(url+authParams)
        .then(response => {
            if(response && !response.errors) {
                resolve(response)
            } else if(response && response.errors){
                reject(response.errors)
            }
        })
        .catch(function(error) {
            reject(error);
        });
    })
}

export function sendLikeForPost(post_id) {

    return new Promise(function(resolve, reject) {
        axios.defaults.headers.common['Content-Type'] = 'application/x-www-form-urlencoded';

        const url = `https://lifetech-api-stg.herokuapp.com/api/v1/post/${localStorage.getItem('user_id')}/add_like?post_id=${[post_id]}`;
        const authParams = `&uid=${localStorage.getItem('uid')}&access-token=${localStorage.getItem('accessToken')}&expiry=${localStorage.getItem('expiry')}&client=${localStorage.getItem('client')}&token-type=Bearer`;
        axios.post(url+authParams)
        .then(response => {
            if(response && !response.errors) {
                resolve(response)
            } else if(response && response.errors){
                reject(response.errors)
            }
        })
        .catch(function(error) {
            reject(error);
        });
    })
}

export function doDeletePost(post_id) {

    return new Promise(function(resolve, reject) {
        axios.defaults.headers.common['Content-Type'] = 'application/x-www-form-urlencoded';

        const url = `https://lifetech-api-stg.herokuapp.com/api/v1/delete_post/${[post_id]}`;
        const authParams = `?uid=${localStorage.getItem('uid')}&access-token=${localStorage.getItem('accessToken')}&expiry=${localStorage.getItem('expiry')}&client=${localStorage.getItem('client')}&token-type=Bearer`;
        axios.delete(url+authParams)
        .then(response => {
            if(response && !response.errors) {
                resolve(response)
            } else if(response && response.errors){
                reject(response.errors)
            }
        })
        .catch(function(error) {
            reject(error);
        });
    })
}

export function doDeleteComment(comment_id) {

    return new Promise(function(resolve, reject) {
        axios.defaults.headers.common['Content-Type'] = 'application/x-www-form-urlencoded';

        const url = `https://lifetech-api-stg.herokuapp.com/api/v1/delete_comment/${[comment_id]}`;
        const authParams = `?uid=${localStorage.getItem('uid')}&access-token=${localStorage.getItem('accessToken')}&expiry=${localStorage.getItem('expiry')}&client=${localStorage.getItem('client')}&token-type=Bearer`;
        axios.delete(url+authParams)
        .then(response => {
            if(response && !response.errors) {
                resolve(response)
            } else if(response && response.errors){
                reject(response.errors)
            }
        })
        .catch(function(error) {
            reject(error);
        });
    })
}

export function doUpdateComment(comment_id,comment) {

    return new Promise(function(resolve, reject) {
        axios.defaults.headers.common['Content-Type'] = 'application/x-www-form-urlencoded';

        const url = `https://lifetech-api-stg.herokuapp.com/api/v1/comments/${comment_id}?text=${comment}`;
        const authParams = `&uid=${localStorage.getItem('uid')}&access-token=${localStorage.getItem('accessToken')}&expiry=${localStorage.getItem('expiry')}&client=${localStorage.getItem('client')}&token-type=Bearer`;
        axios.put(url+authParams)
        .then(response => {
            if(response && !response.errors) {
                resolve(response)
            } else if(response && response.errors){
                reject(response.errors)
            }
        })
        .catch(function(error) {
            reject(error);
        });
    })
}

export function doUpdatePost(post_id,post) {

    return new Promise(function(resolve, reject) {
        axios.defaults.headers.common['Content-Type'] = 'application/x-www-form-urlencoded';

        const url = `https://lifetech-api-stg.herokuapp.com/api/v1/posts/${post_id}?text=${post.text}&link=${post.link_url}`;
        const authParams = `&uid=${localStorage.getItem('uid')}&access-token=${localStorage.getItem('accessToken')}&expiry=${localStorage.getItem('expiry')}&client=${localStorage.getItem('client')}&token-type=Bearer`;
        axios.put(url+authParams,{ body: {data: post.photo}})
        .then(response => {
            if(response && !response.errors) {
                resolve(response)
            } else if(response && response.errors){
                reject(response.errors)
            }
        })
        .catch(function(error) {
            reject(error);
        });
    })
}

export function doGetTWilioToken(user_id) {

    return new Promise(function(resolve, reject) {
        axios.defaults.headers.common['Content-Type'] = 'application/x-www-form-urlencoded';
        const url = `https://lifetech-api-stg.herokuapp.com/api/v1/twilio_tokens/${user_id}`;
        const authParams = `?uid=${localStorage.getItem('uid')}&access-token=${localStorage.getItem('accessToken')}&expiry=${localStorage.getItem('expiry')}&client=${localStorage.getItem('client')}&token-type=Bearer`;
        axios.post(url+authParams)
        .then(response => {
            if(response && !response.errors) {
                resolve(response)
            } else if(response && response.errors){
                reject(response.errors)
            }
        })
        .catch(function(error) {
            reject(error);
        });
    })
}

export function getMeasuresForUser(type_id,_start_date,_end_date,user_id) {

    return new Promise(function(resolve, reject) {
        axios.defaults.headers.common['Content-Type'] = 'application/x-www-form-urlencoded';
        const url = `https://lifetech-api-stg.herokuapp.com/api/v1/measures/user/${user_id}/${type_id}?startDate=${_start_date}&endDate=${_end_date}`;
        const authParams = `&uid=${localStorage.getItem('uid')}&access-token=${localStorage.getItem('accessToken')}&expiry=${localStorage.getItem('expiry')}&client=${localStorage.getItem('client')}&token-type=Bearer`;
        axios.get(url+authParams)
        .then(response => {
            if(response && !response.errors) {
                resolve(response)
            } else if(response && response.errors){
                reject(response.errors)
            }
        })
        .catch(function(error) {
            reject(error);
        });
    })
}

export function getMeasuresModes(_start_date,_end_date) {

    return new Promise(function(resolve, reject) {
        axios.defaults.headers.common['Content-Type'] = 'application/x-www-form-urlencoded';
        const url = `https://lifetech-api-stg.herokuapp.com/api/v1/modes?user_id=${localStorage.getItem('user_id')}&startDate=${_start_date}&endDate=${_end_date}`;
        const authParams = `&uid=${localStorage.getItem('uid')}&access-token=${localStorage.getItem('accessToken')}&expiry=${localStorage.getItem('expiry')}&client=${localStorage.getItem('client')}&token-type=Bearer`;
        axios.get(url+authParams)
        .then(response => {
            if(response && !response.errors) {
                resolve(response)
            } else if(response && response.errors){
                reject(response.errors)
            }
        })
        .catch(function(error) {
            reject(error);
        });
    })
}

export function getEcgImageWithId(_id) {

    return new Promise(function(resolve, reject) {
        axios.defaults.headers.common['Content-Type'] = 'application/x-www-form-urlencoded';
        const url = `https://lifetech-api-stg.herokuapp.com/api/v1/measures/ecg/${_id}?user_id=${localStorage.getItem('user_id')}`;
        const authParams = `&uid=${localStorage.getItem('uid')}&access-token=${localStorage.getItem('accessToken')}&expiry=${localStorage.getItem('expiry')}&client=${localStorage.getItem('client')}&token-type=Bearer`;
        console.log(url+authParams)
        axios.get(url+authParams)
        .then(response => {
            if(response && !response.errors) {
                resolve(response)
            } else if(response && response.errors){
                reject(response.errors)
            }
        })
        .catch(function(error) {
            reject(error);
        });
    })
}


// WEBPACK FOOTER //
// ./src/helpers/registrationHelper.js